import '../../Styles/blank.css'

const NotFoundOrders = () => {
    return ( 
        <div className="notfound">
            <h2>Brak zamówień w tej kategorii</h2>
        </div>
     );
}
 
export default NotFoundOrders;